import { useCallback, useRef } from 'react';

import * as server from '../server';

export const useGetSubmitAdvancedDialog = ({ actionId, windowSessionId }) => {
    const inProgress = useRef(false);

    return useCallback(({ buttonId, failedHTCMDs }) => {
        if (inProgress.current) {
            return;
        }

        inProgress.current = true;

        return server.submitAdvancedDialog({
            actionId,
            buttonId,
            windowSessionId,
            failedHTCMDs
        });
    }, [inProgress, actionId, windowSessionId]);
};
